import { CompleteRegistrationRequest, CompleteRegistrationResponse } from '../completeregistration';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceUrl } from '../utils/api';

export async function completeRegistration(
    request: CompleteRegistrationRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<CompleteRegistrationResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = CompleteRegistrationRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const url = getServiceUrl('authservice', 'completeregistration');

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): CompleteRegistrationResponse => {
        return CompleteRegistrationResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}